export default __webpack_public_path__ + "static/media/DSC_0582.1723f1fd.webp";